module.exports = __webpack_public_path__ + "img/img4.6a77edba.png";